'use client';
import React from 'react';
import AnnouncementBar from '@/components/AnnouncementBar';
import Navbar from '@/components/Navbar';
import HeroBanner from '@/components/HeroBanner';
import CollectionsSection from '@/components/CollectionsSection';
import CustomCTABanner from '@/components/CustomCTABanner';
import TryBeforeYouBuy from '@/components/TryBeforeYouBuy';
import ConferenceKitsSection from '@/components/ConferenceKitsSection';
import StatsBar from '@/components/StatsBar';
import WhyEcosange from '@/components/WhyEcosange';
import ShowcaseSlider from '@/components/ShowcaseSlider';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <main className="min-h-screen bg-white">
      {/* Announcement Bar */}
      <AnnouncementBar />

      {/* Sticky Navigation */}
      <Navbar />

      {/* Hero Banner */}
      <HeroBanner />

      {/* Collections Grid */}
      <CollectionsSection />

      {/* Custom Packaging CTA Banner */}
      <CustomCTABanner />

      {/* Try Before You Buy */}
      <TryBeforeYouBuy />

      {/* Conference Kits */}
      <ConferenceKitsSection />

      {/* Stats Bar */}
      <StatsBar />

      {/* Why Ecosange */}
      <WhyEcosange />

      {/* Showcase Slider */}
      <ShowcaseSlider />

      {/* Contact / Custom Quote */}
      <ContactSection />

      {/* Footer */}
      <Footer />
    </main>
  );
}
